











































import { defineComponent, computed, ref } from '@vue/composition-api';
import SearchField from './SearchField.vue';
import sl from '@/serviceLocator';

export default defineComponent({
  name: 'OareSidebar',
  components: {
    SearchField,
  },
  setup() {
    const store = sl.get('store');
    const text = ref('');
    const translit = ref('');
    const word = ref('');

    const textSearchDisabled = computed(() => word.value.trim() !== '');
    const dictionaryDisabled = computed(() => {
      return text.value.trim() !== '' || translit.value.trim() !== '';
    });

    const performSearch = async () => {
      const routeName = dictionaryDisabled.value
        ? '/search/texts'
        : '/search/dictionary';

      const { protocol, pathname, host } = window.location;
      const urlParams = new URLSearchParams();

      if (text.value) {
        urlParams.set('title', text.value);
      }

      if (translit.value) {
        urlParams.set('translit', translit.value);
      }

      if (word.value) {
        urlParams.set('dictionary', word.value);
      }

      const newUrl = `${protocol}//${host}${routeName}?${urlParams.toString()}`;
      window.location.href = newUrl;
    };

    const canDictionarySearch = computed(
      () =>
        store.hasPermission('WORDS') ||
        store.hasPermission('NAMES') ||
        store.hasPermission('PLACES')
    );

    const canSearch = computed(
      () => text.value || translit.value || word.value
    );

    const clearSearch = () => {
      text.value = '';
      translit.value = '';
      word.value = '';
    };

    return {
      text,
      translit,
      word,
      performSearch,
      textSearchDisabled,
      dictionaryDisabled,
      clearSearch,
      canSearch,
      canDictionarySearch,
    };
  },
});
